import React from 'react';
import { Route, Redirect } from "react-router-dom";
import { selectAuthState } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';
import { useAuthenticator } from "@aws-amplify/ui-react";

export function PrivateRoute({ children, ...rest }) {
    const authState = useSelector(selectAuthState);
    const { route } = useAuthenticator((context) => [context.route]);
    const isAuthenticated = (authState === route ) ? true : false;
  
    return (
        <Route
            {...rest}
            render={({ location }) =>
            isAuthenticated ? (
                children
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: location }
                    }}
                />
            )
            }
        />
    );
}